export default __webpack_public_path__ + "static/media/notes.d459b798.png";